import React, { useState } from 'react';
import { number, shape, string } from 'prop-types';
import {
  Card,
  CardMedia,
  Popover,
  Typography
} from '@one-thd/sui-atomic-components';
import { useImpression } from '@thd-olt-component-react/impression';

const RelatedProductsCard = ({
  itemId, canonicalUrl, image, productLabel, description, index, key
}) => {

  const [anchorElForPopover, setAnchorElForPopover] = useState(null);

  const { ref, clickID } = useImpression({
    data: {
      id: itemId || '',
      name: 'RelatedProductsCard',
      component: 'RelatedProductsCard',
      position: index || 0,
      type: 'product'
    }
  });

  const handleClick = (event) => {
    setAnchorElForPopover(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorElForPopover(null);
  };

  return (
    <div
      key={key}
      ref={ref}
      /* eslint-disable-next-line react/no-unknown-property */
      clickid={clickID}
    >
      <Card
        className="sui-rounded-base sui-border-1"
      >
        <a href={canonicalUrl} tabIndex={0}>
          <CardMedia
            src={`${image?.url}`.replace(/<SIZE>/g, '300')}
            alt={`${productLabel}`.replace(/"/g, '\'\'')}
            aspect="square"
          />
          <Typography
            component="h3"
            variant="body-base"
            weight="bold"
            lineClamp="3"
            height="tight"
          >
            <div className="related-products__title">
              {productLabel}
            </div>
          </Typography>
        </a>
        <Typography
          variant="body-xs"
          lineClamp="2"
          height="tight"
          onClick={handleClick}
        >
          <div className="sui-cursor-pointer">
            {description}
          </div>
        </Typography>
        <Popover
          id="related-products-full-details-popover"
          open={!!anchorElForPopover}
          anchorEl={anchorElForPopover}
          onClose={handleClose}
          placement="top"
        >
          <Typography variant="body-xs">
            {description}
          </Typography>
        </Popover>
        <Typography variant="body-base" weight="regular" decoration="underline">
          <a href={canonicalUrl} tabIndex={0}>View Product</a>
        </Typography>
      </Card>
    </div>
  );

};

RelatedProductsCard.defaultProps = {
  itemId: '',
  canonicalUrl: '',
  image: {},
  productLabel: '',
  description: '',
  index: 0,
  key: ''
};

RelatedProductsCard.propTypes = {
  itemId: string,
  canonicalUrl: string,
  image: shape({}),
  productLabel: string,
  description: string,
  index: number,
  key: string
};

export { RelatedProductsCard };
